import { NgModule } from '@angular/core';
import { ComponentsModule } from 'components/components.module';
import { DirectivesModule } from 'directives/directives.module';
import { UnsubscribePage } from './unsubscribe';
import { PagesModule } from 'pages/pages.module';

@NgModule({
    declarations: [UnsubscribePage],
    imports: [PagesModule, ComponentsModule, DirectivesModule]
})
export class UnsubscribePageModule { }
